// Barcode.tsx
import React, { useEffect, useRef } from 'react'
import JsBarcode from 'jsbarcode'

type Props = {
   value: string
}

const Barcode: React.FC<Props> = ({ value }) => {
   const svgRef = useRef<SVGSVGElement>(null)
   const barcodeValue = String(value ?? '').trim()
   const isBarcodeValueSafe = /^[\x20-\x7E]+$/.test(barcodeValue)

   useEffect(() => {
      if (svgRef.current && isBarcodeValueSafe) {
         svgRef.current.innerHTML = ''
         JsBarcode(svgRef.current, value, {
            format: 'CODE128',
            displayValue: false, // không hiển thị text dưới barcode
            height: 120,
            width: 5
         })
      } else if (svgRef.current) {
         svgRef.current.innerHTML = ''
      }
   }, [value, isBarcodeValueSafe])

   return <svg ref={svgRef}></svg>
}

export default Barcode
